var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"time"},[_c('p',[_vm._v("链接有效期倒计时："),_c('span',[_vm._v(_vm._s(_vm.countdownTime))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }